import React, { useCallback } from 'react';
import { useGuestGuideTelemetry } from '../GuestGuideTelemetry';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useTranslation } from '@shared/core';
import { GuestGuideActionButton } from '../GuestGuideActionButton';
import { Bell } from '@withjoy/joykit/icons';
import { usePriceAlertModal } from '../PriceAlertModalContext';

export const PriceAlertsAction: React.FC = () => {
  const { onOpen } = usePriceAlertModal();
  const telemetry = useGuestGuideTelemetry();
  const { tq } = useTranslation('guestGuide');
  const [accommodationsPriceAlerts] = useIsFeatureEnabled('accommodationsPriceAlerts');

  const handleClick = useCallback(() => {
    telemetry.clickPriceAlerts();
    onOpen();
  }, [telemetry, onOpen]);

  if (!accommodationsPriceAlerts) {
    return null;
  }

  return (
    <GuestGuideActionButton
      icon={<Bell size={32} />}
      onClick={handleClick}
    >
      {tq`Get Price Alerts`}
    </GuestGuideActionButton>
  );
};
